import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { Utiles } from '@/__env/pluggins/event-bus';
import { Guid, Wait } from '@/__env/ext';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import moment, { Moment } from 'moment';

export class ControladorInterfaz extends ControladorBase
{
    public Guid: string;
    public get Progreso(): number
    {
        let pp = this.Operaciones.filter( x => x.Estado == 'facturado' || x.Estado == 'error' ).length
        if ( pp > 0 )
            return ( ( pp / this.Operaciones.length ) * 100 ).round( 0 );
        return 0;
    }

    public get Procesando(): boolean
    {
        return this.Vista.Estado ==  'iniciando' || this.Vista.Estado == 'procesando';
    }

    public Comprobando(): boolean
    {
        return this.Operaciones.filter( x => x.Estado == 'cargando' ).hasRows();
    }

    public get Disponibles(): Operacion[]
    {
        return this.Operaciones.filter( x => x.Estado == 'en-espera' );
    }

    public Operaciones: Operacion[] = [];
    public async Iniciar( x: Pedido[] )
    {
        this.Vista.Estado = 'cargando';
        this.Operaciones.clear();
        for ( let p of x )
        {
            this.Operaciones.push( new Operacion( p ) );
            await Wait( 300 );
        }
        this.Vista.Estado = 'en-espera';

    }

    public Reiniciar()
    {
        this.Vista.Estado = 'cargando';
        this.Operaciones  = [];
        this.Vista.Estado = 'en-espera';
    }

    public Actualizar( e: { pedido: number; estado: string, mensaje: string; } )
    {
        this.UltimoContacto = moment();
        if ( e.pedido )
        {
            this.Vista.Estado = 'procesando';
            let idx = this.Operaciones.findIndex( x => x.Pedido.Id == e.pedido );
            if ( idx != -1 )
            {
                this.Operaciones[idx].Actualizar( e );
            }
        }
        else if ( e.estado == 'finalizado' )
        {
            Utiles.$socket.client.off( 'operaciones-facturacion-' + this.Guid );
            if ( this.Intervalo ) { clearInterval( this.Intervalo ); }
            this.Vista.Estado = 'finalizado';
        }
        else if ( e.estado == 'iniciando' )
        {
            this.Vista.Estado = 'procesando';
        }
    }

    public UltimoContacto: Moment = moment();
    public Intervalo: any= null;
    Ejecutar()
    {
        this.Guid = Guid.create().toString();
        Utiles.$socket.client.on( 'operaciones-facturacion-' + this.Guid,(x:any) => this.Actualizar(x) );

        if ( this.Intervalo )
        {
            clearInterval( this.Intervalo );
        }

        this.Intervalo = setInterval( () => this.IntervaloControl(), 1000 );

        this.UltimoContacto = moment();
        this.Vista.Estado = 'iniciando';
        window.location = `facturar:pedido=${this.Operaciones.map( x => x.Pedido.Id ).join( ',' )};ope=${this.Guid};token=R4D8S4d-aw5f1h8f6-d4a8s5w8d6x`;

    }

    IntervaloControl()
    {
        if ( this.Vista.Estado == 'iniciando' )
        {
            let dif = moment().diff( this.UltimoContacto , 'seconds' );
            if ( dif > 10 )
            {
                this.Cancelar();

            }
        }
        else if ( this.Vista.Estado == 'procesando' )
        {
            let dif = moment().diff( this.UltimoContacto , 'seconds' );
            if ( dif >= 60 )
            {
                this.Cancelar();

            }
        }

    }

    Cancelar()
    {
        for ( let p of this.Operaciones )
        {
            if ( p.Estado != 'facturado' )
            {
                p.Errores.push( 'Cancelado' );
                p.Estado = 'error';
            }
        }
        this.Vista.Estado = 'cancelado';
        Utiles.$socket.client.off( 'operaciones-facturacion-' + this.Guid );
        if ( this.Intervalo ) { clearInterval( this.Intervalo ); }
    }
}

export const Controlador = new ControladorInterfaz();


export class Operacion
{
    constructor( pedido: Pedido )
    {
        this.Pedido = pedido;
        if ( this.Pedido.Cliente.CondicionIva.FacturaA )
        {
            this.Comprobante = 'A';
        }
        else
        {
            this.Comprobante = 'B';
        }

    }

    public async Iniciar()
    {
        this.Estado = 'cargando';
        await Wait( 100 );
        this.Pedido = await Pedido.create( this.Pedido.Id );
        let e = this.Pedido.ComprobarFacturacion();
        if ( e.hasRows() )
        {
            this.Errores = e;
            this.Estado = 'error';
        }
        else
        {
            this.Estado = 'en-espera';
        }

    }

    public Pedido: Pedido;
    public EmiteGuiaEnPie: boolean = true;
    public Mensaje: string = '';
    public Comprobante: string = '';
    public Errores: string[] = [];
    public estado: string | 'cargando' | 'en-espera' | 'iniciando' | 'facturando' | 'facturado' | 'error' = 'cargando';
    get Estado(): string { return this.estado; }
    set Estado( m: string ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    public Actualizar( e: { pedido: number; estado: string, mensaje: string; } )
    {
        if ( e.estado == 'error' )
        {
            this.Estado = 'error';
            if ( e.mensaje )
                this.Errores.push( e.mensaje );
        } else if ( e.estado == 'iniciando' )
        {
            this.Estado = 'iniciando';
            if ( e.mensaje )
                this.Mensaje = e.mensaje;
        } else if ( e.estado == 'facturando' )
        {
            this.Estado = 'facturando';
            if ( e.mensaje )
                this.Mensaje = e.mensaje;
        } else if ( e.estado == 'facturado' )
        {
            this.Estado = 'facturado';

        }
    }
}